import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Program } from '~shared/api/categories/types'

interface ProgramWithColor extends Program {
  duration: number
  format: string
  faculty: Program['faculty'] & {
    color: string | null | undefined
  }
}
type TSearchParams = {
  duration: { slug: string; name: string }
  faculty: { slug: string; name: string }
  category: { slug: string; name: string }
  format: { slug: string; name: string }
}

export const programsFilter = (
  categories: Awaited<ReturnType<typeof getCategoriesData>>
) => {
  return [
    {
      filterName: {
        name: 'Уровень образования' as string | null,
        slug: 'category' as string | null
      },
      list:
        categories?.categories?.map(el => ({ slug: el.slug, name: el.name })) ??
        []
    },
    {
      filterName: {
        name: 'Специальности' as string | null,
        slug: 'faculty' as string | null
      },
      list:
        categories?.faculties?.map(el => ({ slug: el.slug, name: el.name })) ??
        []
    },
    {
      filterName: {
        name: 'Срок обучения' as string | null,
        slug: 'duration' as string | null
      },
      list: [
        { slug: '11', name: 'меньше года' },
        { slug: '12-24', name: '1-2 года' },
        { slug: '25', name: 'от 2-х лет' }
      ]
    },
    {
      filterName: {
        name: 'Формат обучения' as string | null,
        slug: 'format' as string | null
      },
      list: [
        { slug: 'dist', name: 'дистанционно' },
        { slug: 'hybrid', name: 'гибрид' }
      ]
    }
  ]
}

export const filteredPrograms = (
  allPrograms: ProgramWithColor[],
  searchParams: TSearchParams
) => {
  // сортируем по полю forMainPage если не выбран ни один из фильтров.
  const isAllFiltersDefault = Object.values(searchParams).every(
    val => val.slug === 'all'
  )
  if (isAllFiltersDefault) {
    return allPrograms.sort((a, b) => {
      if (a.forMainPage && !b.forMainPage) {
        return -1 // a идёт перед b
      }
      if (!a.forMainPage && b.forMainPage) {
        return 1 // b идёт перед a
      }
      return 0 // если оба или ни один не forMainPage
    })
  }

  return allPrograms?.filter(program => {
    const { duration, faculty, category, format } = searchParams

    const matchCategory =
      category.slug === 'all' || program?.category?.slug === category.slug
    const matchFaculty =
      faculty.slug === 'all' || program.faculty.slug === faculty.slug
    const matchFormat = format.slug === 'all' || program?.format === format.slug

    let matchDuration = true
    if (duration.slug !== 'all') {
      const dur = program?.duration || 0
      if (duration.slug === '11') {
        matchDuration = dur < 12
      } else if (duration.slug === '12-24') {
        matchDuration = dur >= 12 && dur <= 24
      } else if (duration.slug === '25') {
        matchDuration = dur > 24
      }
    }

    return matchCategory && matchFaculty && matchDuration && matchFormat
  })
}
